import { LayoutConfig } from '@spartacus/storefront';

export const layoutSlotsConfig: LayoutConfig = {
  layoutSlots: {
    topContentSlots: { slots: ['BreadcrumbsSlot', 'BottomHeaderSlot', 'H1Slot', 'TopPromo'] },

    headerTop: {
      lg: {
        slots: ['SiteLogo', 'SiteContextHeader', 'ShopLinks', 'SwitchProfile', 'NavigationBar'],
      },
      md: {
        slots: ['SiteContextHeader', 'ShopLinks', 'SiteLogo', 'SwitchProfile', 'SiteContacts'],
      },
      slots: ['SiteLogo', 'SiteContextHeader', 'SwitchProfile'],
    },
    headerBottom: {
      lg: {
        slots: [
          'CategoriesMenu',
          'SearchBox',
          'SiteContacts',
          'SiteLoginButton',
          'ComparisonSlot',
          'WishlistSlot',
          'MiniCart',
          'CartList',
        ],
      },
      md: {
        slots: ['PreHeader', 'SearchBox', 'SiteLoginButton', 'WishlistSlot', 'MiniCart'],
      },
      slots: ['SearchBox', 'SiteContacts', 'ChatMenuMobile'],
    },
    headerSubstrate: {
      slots: ['Substrate', 'SubstrateContent'],
    },
    relativeCatalog: {
      lg: {
        slots: ['CategoriesMenu', 'SearchBox'],
      },
      slots: [],
    },
    mobileNavigation: {
      slots: ['MobileMenu'],
    },
    mobileMenuHeader: {
      slots: ['SiteLogo'],
    },
    mobileMenuBody: {
      slots: ['CategoriesMenu', 'CartList', 'ComparisonSlot', 'NavigationBar', 'SiteContacts', 'LoginMenuLinks'],
    },
    tabBar: {
      md: {
        slots: [],
      },
      slots: ['TabBar'],
    },
    footerNavigation: {
      slots: ['FooterNavigation', 'FooterMainNavigation'],
    },
    footerContacts: {
      slots: ['FooterPhone', 'FooterAppLinks', 'FooterEmail', 'FooterSocialLinks'],
    },
    footerBottom: {
      slots: ['FooterLinks', 'FooterCopyright'],
    },
    CartPageTemplate: {
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'TopContent',
          'CenterRightContentSlot',
          'EmptyCartMiddleContent',
          'BottomContentSlot',
        ],
      },
      slots: [
        'BottomHeaderSlot',
        'H1Slot',
        'TopPromo',
        'TopContent',
        'CenterRightContentSlot',
        'EmptyCartMiddleContent',
        'BottomContentSlot',
      ],
    },
    AccountPageTemplate: {
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'SideContent',
          'SideContent2',
          'BodyContent',
        ],
      },
      slots: ['BottomHeaderSlot', 'H1Slot', 'TopPromo', 'SideContent', 'SideContent2', 'BodyContent'],
    },
    SdPromoCampaignPageTemplate: {
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'BottomHeaderSlot-Promo',
          'ContentList',
          'CategoryBanners',
          'ProductLeftRefinements',
          'ProductGridSlot',
          'Section4',
        ],
      },
      slots: [
        'BottomHeaderSlot',
        'H1Slot',
        'TopPromo',
        'BottomHeaderSlot-Promo',
        'ContentList',
        'CategoryBanners',
        'ProductLeftRefinements',
        'ProductGridSlot',
        'Section4',
      ],
    },
    SdPromoContentPageTemplate: {
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'BannerSection',
          'TopPromoContent',
          'BottomPromoContent',
          'ContentList',
          'ContentColumns',
          'CategoryBanners',
          'ContentListExtra',
        ],
      },
      slots: [
        'BottomHeaderSlot',
        'H1Slot',
        'TopPromo',
        'BannerSection',
        'TopPromoContent',
        'BottomPromoContent',
        'ContentList',
        'ContentColumns',
        'CategoryBanners',
        'ContentListExtra',
      ],
    },
    ProductDetailsPageTemplate: {
      slots: ['Summary', 'Sidebar', 'BodyContent', 'PlaceholderContentSlot'],
    },
    SingleStepCheckoutSummaryPageTemplate: {
      lg: {
        slots: ['BottomHeaderSlot', 'H1Slot', 'TopPromo', 'DesktopContent', 'BodyContent', 'SideContent'],
      },
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'MobileContent',
          'BodyContent',
          'SideContent',
        ],
      },
      slots: ['BottomHeaderSlot', 'H1Slot', 'TopPromo', 'MobileContent', 'BodyContent', 'SideContent'],
    },
    PromoLandingPageTemplate: {
      md: {
        slots: ['BreadcrumbsSlot', 'BottomHeaderSlot', 'H1Slot', 'TopPromo', 'BannerSection'],
      },
      slots: ['BottomHeaderSlot', 'H1Slot', 'TopPromo', 'BannerSection'],
    },
    LandingPage2Template: {
      slots: [
        'SectionContent1',
        'SectionContent2',
        'BannerSection',
        'SectionContent3',
        'SectionContent4',
        'SectionContent5',
        'SectionContent6',
        'SectionContent7',
        'SectionContent8',
      ],
    },
    ContentPage1Template: {
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'BannerSection',
          'TopContent',
          'ContentTopBanner',
          'Section1',
          'Section2A',
          'Section2B',
          'Section2C',
          'Section3',
        ],
      },
      slots: [
        'BottomHeaderSlot',
        'H1Slot',
        'TopPromo',
        'BannerSection',
        'TopContent',
        'ContentTopBanner',
        'Section1',
        'Section2A',
        'Section2B',
        'Section2C',
        'Section3',
      ],
    },
    ArticlePageTemplate: {
      md: {
        slots: [
          'BreadcrumbsSlot',
          'BottomHeaderSlot',
          'H1Slot',
          'TopPromo',
          'ArticleDetailDate',
          'ArticleTopBanner',
          'ArticleDetailReadingTime',
          'ArticleDetailTableOfContent',
          ...Array.from({ length: 30 }, (_, i) => `ArticleDetailSection${i + 1}`),
          'ArticleDetailRating',
          'ArticleDetailCrossLinks',
          'ArticleSectionBottom',
        ],
      },
      slots: [
        'BottomHeaderSlot',
        'H1Slot',
        'TopPromo',
        'ArticleDetailDate',
        'ArticleTopBanner',
        'ArticleDetailReadingTime',
        'ArticleDetailTableOfContent',
        ...Array.from({ length: 30 }, (_, i) => `ArticleDetailSection${i + 1}`),
        'ArticleDetailRating',
        'ArticleDetailCrossLinks',
        'ArticleSectionBottom',
      ],
    },
    OrderConfirmationPageTemplate: {
      md: {
        slots: ['BreadcrumbsSlot', 'BottomHeaderSlot', 'H1Slot', 'TopPromo', 'BodyContent', 'BottomContent'],
      },
      slots: ['BottomHeaderSlot', 'H1Slot', 'TopPromo', 'BodyContent', 'BottomContent'],
    },
    TextContentPageTemplate: {
      slots: ['TextContentSection'],
    },
    ProductListPageTemplate: {
      slots: ['ProductLeftRefinements', 'ProductListSlot', 'Section4'],
    },
    ProductGridPageTemplate: {
      slots: ['ProductLeftRefinements', 'ProductGridSlot', 'Section4'],
    },
    SearchResultsGridPageTemplate: {
      slots: ['Section2', 'ProductLeftRefinements', 'SearchResultsGridSlot', 'Section4'],
    },
  },
};
